module.exports ={
    API_KEY:"4bf81f897d8d68a0e754e8451c13660e",
    BASE_URL:"https://api.openweathermap.org/data/2.5/"
}